var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeature2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 71,
    viewBox: "0 0 70 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.7056 34.8602C69.4147 15.5298 53.7881 0.107796 34.8159 0.404102C15.8368 0.700407 0.695064 16.6162 0.985985 35.9396C1.27691 55.27 16.9035 70.692 35.8757 70.3957C54.8548 70.0994 70.0035 54.1906 69.7056 34.8602Z",
    fill: "url(#paint0_linear_317_1874)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.855 63.3999C19.9431 63.3999 7.85469 51.0877 7.85469 35.8999C7.85469 20.7121 19.9431 8.3999 34.855 8.3999C49.7669 8.3999 61.8553 20.7121 61.8553 35.8999C61.8553 51.0877 49.7669 63.3999 34.855 63.3999Z",
    fill: "#B897FD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.535 23.2914L33.5651 21.3999L37.1524 21.4502L37.1224 23.3416C40.2238 23.9675 41.782 26.1697 41.7219 29.6237L41.7068 30.4232L37.5583 30.3638L37.5783 29.3084C37.6084 27.49 36.8218 26.7865 35.4289 26.7682C34.036 26.7499 33.2243 27.4261 33.1943 29.2444C33.1041 34.4802 41.6718 34.8549 41.5515 42.1238C41.4914 45.5777 39.8229 47.7707 36.7015 48.3098L36.6715 50.1647L33.0841 50.1145L33.1141 48.2596C29.9726 47.6337 28.4194 45.395 28.4746 41.941L28.5046 40.1957L32.6532 40.2551L32.6181 42.2562C32.588 44.0746 33.4548 44.7416 34.8477 44.7599C36.2456 44.7782 37.1324 44.1386 37.1625 42.3202C37.2526 37.0844 28.685 36.7098 28.8052 29.4409C28.8654 26.028 30.4586 23.867 33.535 23.2914Z",
    fill: "#3B3B3B"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_317_1874",
    x1: 14.8461,
    y1: 0.399902,
    x2: 72.7575,
    y2: 68.6317,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA99FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEC0FD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeature2);
export default __webpack_public_path__ + "static/media/feature2.12d1c5237a1ee79dd8c3b108dcaf11e5.svg";
export { ForwardRef as ReactComponent };